import { Injectable } from '@angular/core';
// import { Platform } from '@ionic/angular';

import type { TCoordinate, TDistance, TDomainInfo, TSpeed, TRole, TDistinctColorInfo } from '@shared/models';
import { Constants } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class UtilsService {
    private readonly DEGREES_TO_RADIANS = 180;
    private readonly METERS_PER_KILOMETER = 1000;
    private readonly KILOMETERS_PER_MILE = 0.621371;
    // private readonly SECONDS_PER_MINUTE = 60;

    // private readonly UPPERCASE_ALPHA_START = 64;
    // private readonly UPPERCASE_ALPHA_END = 91;
    // private readonly LOWERCASE_ALPHA_START = 96;
    // private readonly LOWERCASE_ALPHA_END = 123;
    // private readonly NUMERIC_START = 96;
    // private readonly NUMERIC_END = 123;

    // private platform: Platform
    // constructor() {
    // }

    // Moved back to mapHelper
    // public onDevice(): boolean {
    //     const onDevice: boolean = this.platform.is('cordova');
    //     return onDevice;
    // }

    public countCh(str: string, ch: string) {
        let result = 0;
        for (let i = 0; i < str.length; i++) {
            if (str[i] === ch) {
                result++;
            }
        }
        return result;
    }

    public sprintf(format: string, ...args: string[]) {
        let i = 0;
        return format.replace(/%s/g, () => args[i++]);
    }

    // public padWithLeadingZeros(num, size) {
    //     num = num.toString();
    //     while (num.length < size) num = "0" + num;
    //     return num;
    // }

    public replaceAll(src: string, search: string, replaceWith: string): string {
        if (!src || !search || !replaceWith) {
            return src;
        }
        const newSrc = src.split(search).join(replaceWith);
        return newSrc;
    }

    public replaceCh(src: string, search: string, replaceWith: string): string {
        if (!src || !search) {
            return src;
        }
        let newSrc = src;
        const invalidChars = search.split('');
        invalidChars.forEach((ch) => {
            newSrc = newSrc.replace(ch, replaceWith);
        });
        return newSrc;
    }

    public allEqual(input: string): boolean {
        if (!input) {
            return false;
        }
        const chars = input.split('');
        const allCharsEqual = chars.every((char) => char === input[0]);
        return allCharsEqual;
    }
    // public getRegionInfo(stateOrStateCode: string): TRegionInfo {
    //     let stateInfo: TRegionInfo;
    //     if (stateOrStateCode.length === 2) {
    //         const infos: a-n-y = Constants.US_STATES.filter((item: TRegionInfo) => {

    // Creates a deep copy - a totally different and distinct object from the incoming obj.
    // public deepClone(obj: any) {
    //     const deepClone = JSON.parse(JSON.stringify(obj));
    //     return deepClone;
    // }
    public deepClone(obj: any): any {
        const deepClone = JSON.parse(JSON.stringify(obj));
        return deepClone;
    }

    // TODO: If the backend is using this method, then rewrite it to use the new methods.
    // public geTUSRegions(stateOrStateCode: string): TUSRegions {
    //     let stateInfo: TUSRegions;
    //     if (stateOrStateCode.length === 2) {
    //         const infos: a-n-y = Constants.US_STATES.filter((item: TUSRegions) => {
    //             return (item.regionCode === stateOrStateCode);
    //         });
    //         stateInfo = infos[0];
    //     } else {
    //         const infos: a-n-y = Constants.US_STATES.filter((item: TRegionInfo) => {
    //         const infos: a-n-y = Constants.US_STATES.filter((item: TUSRegions) => {
    //             return (item.regionName === stateOrStateCode);
    //         });
    //         stateInfo = infos[0];
    //     }
    //     return stateInfo;
    // }

    // public getRandomInt(min, max) {
    //     const num = Math.floor(Math.random() * (max - min + 1)) + min;
    //     return num;
    // }

    public isBlank(val: string) {
        if (!val) {
            return true;
        }
        const str = val.toString();
        const hasValue = (str && str.trim().length > 0);
        return !hasValue;
    }

    // This method has not been debugged.
    public toTitleCase(sentence: string) {
        const words = sentence.split(' ');
        // const newWords = words.map((word) => {
        //     return (word.charAt(0).toUpperCase() + word.slice(1));
        // });
        const newWords = words.map((word) => (word.charAt(0).toUpperCase() + word.slice(1)));
        const newSentence = newWords.join(' ');
        return newSentence;
    }

    public formatAddressForGoogleMaps(street: string, city: string, regionName: string, zipcode: string, country: string) {
        const part1 = street;
        const part2 = city + ' ' + regionName;
        const part3 = zipcode;
        const part4 = country;

        // When displaying a long address on the phone, the address is being truncated.
        // At this point, I don't really need the USA/part4.  So leave it off.
        //        var fullAddress = part1 + ', ' + part2 + ', ' + part3;  // + ', ' + part4;
        let fullAddress = '';
        fullAddress += (part1) ? part1 + ', ' : '';
        fullAddress += (part2) ? part2 + ', ' : '';
        fullAddress += (part3) ? part3 + ', ' : '';
        fullAddress += (part4) ? part4 : '';
        return fullAddress;
    }

    public async sleep(ms: number): Promise<void> {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    // public async timeoutHandler() {
    //     await this.sleep(1)
    //     // heavy duty code here
    // }

    // // setTimeout(timeoutHandler, 10000)


    // Incoming phone number: 12135551234
    // return phone number: (xxx) xxx-1234
    // TODO: This method has not been debugged.
    public maskPhoneNumber(phoneNumber: string, countryCode = '1'): string {
        if (!phoneNumber) {
            return '';
        }
        const pn = this.unformatPhoneNumber(phoneNumber);
        const phoneNumberWithoutCountryCodeLength = pn.length;
        const phoneNumberWithCountryCodeLength = pn.length + countryCode.length;

        if (!pn || (pn.length !== 10 && pn.length !== phoneNumberWithCountryCodeLength)) {
            return '';
        }

        if (pn.length === phoneNumberWithoutCountryCodeLength) {
            const last = pn.slice(6);
            const maskedPhoneNumber = '(xxx) xxx-' + last;
            return maskedPhoneNumber;
        }
        if (pn.length === phoneNumberWithCountryCodeLength) {
            const last = pn.slice(7);
            const maskedPhoneNumber = '(xxx) xxx-' + last;
            return maskedPhoneNumber;
        }
        return '';
    }

    public formatCoordinateForDisplay(coordinate: TCoordinate) {
        const lat = this.round(coordinate.latitude, 6);
        const lng = this.round(coordinate.longitude, 6);
        const str = `(${lat}, ${lng})`;
        return str;
    }

    public formatPhoneNumberForDialer(phoneNumber: string) {
        if (!phoneNumber) {
            return null;
        }

        if (phoneNumber.indexOf('tel:') === -1) {
            const prefix = 'tel:+';
            const countryCode = '1';
            const formattedPhoneNumber = prefix + countryCode + phoneNumber;
            return formattedPhoneNumber;
        } else {
            return phoneNumber;
        }
    }

    public formatPhoneNumberForDisplay(phoneNumber: string): string {
        if (!phoneNumber) {
            return '';
        }

        const pn = this.unformatPhoneNumber(phoneNumber);
        if (!pn) {
            return '';
        }
        const areacode = pn.substring(0, 3);
        const prefix = pn.substring(3, 6);
        const final = pn.substring(6);
        const formatted = '(' + areacode + ') ' + prefix + '-' + final;
        return formatted;
    }

    // Remove these characters:  -+() and spaces
    public unformatPhoneNumber(phoneNumber: string): string {
        if (!phoneNumber) {
            return '';
        }
        phoneNumber = phoneNumber.replace(/[-+()\s]/g, '');
        return phoneNumber;
    }

    public getDomainInfo(): TDomainInfo {
        const location = window.location;
        const hostname = location.hostname.toLowerCase();

        // if (hostname === '127.0.0.1' || hostname.includes('localhost')) {
        //     domain = 'localhost';
        // } else if (hostname.includes('staging')) {
        //     domain = 'staging';
        // } else if (hostname.includes('app')) {
        //     domain = 'app';
        // }  else if (hostname.includes('backend')) {
        //     domain = 'backend';
        // }

        let domain = '';
        if (hostname.includes('backend')) {
            domain = 'backend';
        } else if (hostname.includes('app')) {
            domain = 'app';
        } else {
            domain = 'staging';
        }

        if (!domain) {
            throw new Error('Unknown  = domain');
        }

        let properOrigin = '';
        if (location.origin.includes('localhost')) {
            properOrigin = 'https://staging.shuttlenomix.com';
        } else {
            properOrigin = location.origin;
        }

        const domainInfo: TDomainInfo = {
            'domain': domain,
            'domainWithPort': location.host,
            'origin': location.origin,
            'properOrigin': properOrigin
        };

        // console.log('domainInfo = ', JSON.stringify(domainInfo));
        return domainInfo;
    }

    private getDomain() {
        const location = window.location;
        const hostname = location.hostname.toLowerCase();

        let domain: string;
        if (hostname.includes('localhost')) {
            domain = 'staging';
        } else if (hostname.includes('staging')) {
            domain = 'staging';
        } else if (hostname.includes('app')) {
            domain = 'app';
        } else if (hostname.includes('backend')) {
            domain = 'backend';
        } else {
            throw new Error('Unknown domain');
        }

        return domain;
    }

    public getLogRocketAppID(): string {
        let appID: string;
        const domain = this.getDomain();
        switch (domain) {
            case 'localhost':
                appID = Constants.LOGROCKET_APPID_LOCALHOST;
                break;

            case 'staging':
                appID = Constants.LOGROCKET_APPID_STAGING;
                break;

            case 'app':
                appID = Constants.LOGROCKET_APPID_APP;
                break;

            case 'backend':
                appID = Constants.LOGROCKET_APPID_BACKEND;
                break;

            default:
                throw new Error('Unknown domain');
        }
        return appID;
    }

    public buildQueryString(params: string) {
        const esc = encodeURIComponent;
        const query = Object.keys(params)
            .map((k: any) => esc(k) + '=' + esc(params[k]))
            .join('&');
        return query;
    }

    // --------------------------------------------------------------------------
    //  This routine calculates the distance between two points (given the
    //  latitude/longitude of those points). It is being used to calculate
    //  the distance between two locations using GeoDataSource (TM) products
    //
    //  Definitions:
    //    South latitudes are negative, east longitudes are positive
    //
    //  Passed to function:
    //    lat1, lon1 = Latitude and Longitude of point 1 (in decimal degrees)
    //    lat2, lon2 = Latitude and Longitude of point 2 (in decimal degrees)
    //    unit = the unit you desire for results
    //           where: 'M' is statute miles (default)
    //                  'K' is kilometers
    //                  'N' is nautical miles
    //
    //  Worldwide cities and other features databases with latitude longitude
    //  are available at https://www.geodatasource.com
    //
    //  For enquiries, please contact sales@geodatasource.com
    //
    //  Official Web site: https://www.geodatasource.com
    //
    //               GeoDataSource.com (C) All Rights Reserved 2018
    //
    // --------------------------------------------------------------------------
    // public calculateDistance(coordinate1: TCoordinate, coordinate2: TCoordinate, unit: string = 'M'): number {
    //     const lat1 = coordinate1.latitude;
    //     const lon1 = coordinate1.longitude;
    //     const lat2 = coordinate2.latitude;
    //     const lon2 = coordinate2.longitude;

    //     if ((lat1 === lat2) && (lon1 === lon2)) {
    //         return 0;
    //     } else {
    //         const radlat1 = Math.PI * lat1 / 180;
    //         const radlat2 = Math.PI * lat2 / 180;
    //         const theta = lon1 - lon2;
    //         const radtheta = Math.PI * theta / 180;
    //         let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    //         if (dist > 1) {
    //             dist = 1;
    //         }
    //         dist = Math.acos(dist);
    //         dist = dist * 180 / Math.PI;
    //         // dist = dist * 60 * 1.1515;
    //         if (unit === 'K') { dist = dist * 1.609344; }
    //         if (unit === 'N') { dist = dist * 0.8684;   }

    //         return dist;
    //     }
    // }

    private toRadians(value: number): number {
        return value * Math.PI / this.DEGREES_TO_RADIANS;
    }

    // This formula was taken from: www.movable-type.co.uk/scripts/latlong.html
    // As the Crow flies - Calculation in due consideration of Earth curvation
    public calculateDistance(coordinate1: TCoordinate, coordinate2: TCoordinate): TDistance {
        const maxDistance = { 'miles': Number.MAX_SAFE_INTEGER, 'kilometers': Number.MAX_SAFE_INTEGER };

        if (!coordinate1 || !coordinate1.latitude || !coordinate1.longitude ||
            !coordinate2 || !coordinate2.latitude || !coordinate2.longitude) {
            return maxDistance;
        }
        // if (coordinate1.latitude == 0 || coordinate1.longitude == 0 ||
        // 	coordinate2.latitude == 0 || coordinate2.longitude == 0) {
        // 	return null;
        // }

        const R = 6371e3;		// Radius of earth in meters;

        // When I figure out how to add toRadians to the Number type without typescript complaining
        // then put this back.
        // let φ1 = coordinate1.latitude.toRadians();
        // let λ1 = coordinate1.longitude.toRadians();
        // let φ2 = coordinate2.latitude.toRadians();
        // let λ2 = coordinate2.longitude.toRadians();
        const φ1 = this.toRadians(coordinate1.latitude);
        const λ1 = this.toRadians(coordinate1.longitude);
        const φ2 = this.toRadians(coordinate2.latitude);
        const λ2 = this.toRadians(coordinate2.longitude);

        const Δφ = φ2 - φ1;
        const Δλ = λ2 - λ1;

        const a = (Math.sin(Δφ / 2) * Math.sin(Δφ / 2)) + ((Math.cos(φ1) * Math.cos(φ2)) * (Math.sin(Δλ / 2) * Math.sin(Δλ / 2)));
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c;

        const kilometers = d / this.METERS_PER_KILOMETER;
        const miles = kilometers * this.KILOMETERS_PER_MILE;

        const kilometersRounded = Math.round(kilometers * 100) / 100;
        const milesRounded = Math.round(miles * 100) / 100;
        const obj = { 'kilometers': kilometersRounded, 'miles': milesRounded };

        return obj;
    }

    public calculateSpeed(coordinate1: TCoordinate, coordinate2: TCoordinate, secs: number) {
        const nullcoordinate = { 'latitude': 0, 'longitude': 0 };
        const nullSpeed: TSpeed = { 'mph': 0, 'kph': 0 };

        if ((coordinate1 === nullcoordinate) || (coordinate2 === nullcoordinate)) {
            return nullSpeed;
        }

        const secInHour = 3600;

        const dist: TDistance = this.calculateDistance(coordinate1, coordinate2);
        const mph = (dist.miles / secs) * secInHour;
        const kph = (dist.kilometers / secs) * secInHour;

        const speed: TSpeed = {
            'mph': this.round(mph, 2),
            'kph': this.round(kph, 2)
        };
        return speed;
    }

    public calculateSpeedFromMetersPerSecond(metersPerSecond: number): TSpeed {
        const nullSpeed: TSpeed = { 'mph': 0, 'kph': 0 };
        const secondsPerHour = 3600;
        const metersPerMile = 1609.34;
        const metersPerKilometer = 1000;

        if ((metersPerSecond < 1)) {
            return nullSpeed;
        }

        const kph = (metersPerSecond / metersPerKilometer) * secondsPerHour;
        const mph = (kph * metersPerKilometer) / metersPerMile;

        const speed: TSpeed = {
            'mph': this.round(mph, 2),
            'kph': this.round(kph, 2)
        };
        return speed;
    }

    // round(12345.6789, 2)   // 12345.68
    // round(12345.6789, 1)   // 12345.7
    public round(value: number, numDecimalPlaces: number) {
        const multiplier = Math.pow(10, numDecimalPlaces || 0);
        return Math.round(value * multiplier) / multiplier;
    }

    /**
     * This function allow you to modify a JS Promise by adding some status properties.
     * Based on: http://stackoverflow.com/questions/21485545/is-there-a-way-to-tell-if-an-es6-promise-is-fulfilled-rejected-resolved
     * But modified according to the specs of promises : https://promisesaplus.com/

     Usage:
     // Your promise won't cast the .then function but the returned by MakeQuerablePromise
        var originalPromise = new Promise(function(resolve,reject){
            setTimeout(function(){
                resolve("Yeah !");
            },10000);
        });

        var myPromise = MakeQuerablePromise(originalPromise);

        console .log("Initial fulfilled:", myPromise.isFulfilled());//false
        console .log("Initial rejected:", myPromise.isRejected());//false
        console .log("Initial pending:", myPromise.isPending());//true

        myPromise.then(function(data){
            console .log(data); // "Yeah !"
            console .log("Final fulfilled:", myPromise.isFulfilled());//true
            console .log("Final rejected:", myPromise.isRejected());//false
            console .log("Final pending:", myPromise.isPending());//false
        });
     */
    /*
    public makeQuerablePromise(promise: a-n-y) {
        // Don't modify any promise that has already been resolved.
        if (promise.isFulfilled) {
            return promise;
        }

        // Set initial regionName
        let isPending = true;
        let isRejected = false;
        let isFulfilled = false;

        // Observe the promise, saving the fulfillment in a closure scope.
        const result = promise.then(
            function(v: a-n-y) {
                isFulfilled = true;
                isPending = false;
                return v;
            },
            function(e: a-n-y) {
                isRejected = true;
                isPending = false;
                throw e;
            }
        );

        result.isFulfilled = function() { return isFulfilled; };
        result.isPending = function() { return isPending; };
        result.isRejected = function() { return isRejected; };
        return result;
    }
*/
    // Make certain the incoming email address is of the correct form.
    public validateEmailAddress(email: string): boolean {
        // // According to this stackoverflow article,
        // // https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
        // // it says 1) Dont' try to validate an email address with regular expressions, cuz their are always wrong
        // // 2) the only way to guarantee a valid email address is to send them an email and have them respond.
        // // My first version was a regex and I couldn't understand it.  So I chose a brute force version.
        // // A valid email address is of this form:  namePart@domainPart.extPart
        // // let email9 = '';
        // // const ampCount1 = this.utilsService.countCh(email9, '@');

        // // email9 = 'D';
        // // const ampCount2 = this.utilsService.countCh(email9, '@');

        // // email9 = 'D@asdf';
        // // const ampCount3 = this.utilsService.countCh(email9, '@');

        // // email9 = 'Dsdf@dfgb@';
        // // const ampCount4 = this.utilsService.countCh(email9, '@');

        // if (!email) {
        //     return false;
        // }

        // // const ampCount = email.match(/@/g).length;
        // const ampCount = this.countCh(email, '@');
        // if (ampCount === 0 || ampCount > 1) {
        //     return false;
        // }

        // let parts = email.split('@');
        // // if (parts.length !== 2) {
        // if (parts[1].length === 0) {
        //     return false;
        // }

        // const namePart = parts[0];
        // parts = parts[1].split('.');
        // const domainPart = parts[0];
        // const extPart = parts[1];

        // if (!extPart) {
        //     return false;
        // }

        // const valid = (namePart.length > 0 && domainPart.length > 0 && extPart.length > 0);
        // return valid;

        // const format = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|
        //     (\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|
        //     (([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        // https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript
        //        const format = '/^[^\s@]+@[^\s@]+\.[^\s@]+$/';
        const format = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const re = new RegExp(format);
        const passed = re.test(email);
        return passed;
    }

    // Validate the incoming email and password.
    // public validateLoginCredentials(email, password) {
    //     let success = this.utilsService.validateEmailAddress(email);
    //     if (success) {
    //         success = this.validatePassword(password);
    //     }
    //     return success;
    // }

    // Firebase's requirement is that passwords are at least 6 chars.
    public validatePassword(password: string) {
        const valid = (password && password.length > 5);
        return valid;
    }

    // Generate a method that tests if all the characters in a string are alphanumeric
    public isAlphaNumeric(str: string): boolean {
        const alphanumericRegex = /^[a-z0-9]+$/i;   // The i flag makes the match case-insensitive.
        return alphanumericRegex.test(str);
    }

    // ptb TODO: Determine if this is needed.  If needed put it back.
    // public sort(arr: any[], sortColumn: string, sortAscending = true): any {
    //     if (arr.length < 2) {
    //         return arr;
    //     }

    //     const sortedArray = arr.sort((a, b) => {
    //         if (a[sortColumn] < b[sortColumn]) {
    //             // return -1;
    //             return (sortAscending ? -1 : 1);
    //         } else if (a[sortColumn] > b[sortColumn]) {
    //             // return 1;
    //             return (sortAscending ? 1 : -1);
    //         } else {
    //             return 0;
    //         }
    //     });
    //     return sortedArray;
    // }

    public formatAsCurrency(dollars: number): string {
        let retval = '';
        const options: Intl.NumberFormatOptions = {
            style: 'currency',
            currency: 'USD',
        };
        const formatter = new Intl.NumberFormat('en-US', options);

        if (typeof dollars === 'number') {
            retval = formatter.format(dollars);
        }

        return retval;
    }

    // Usage:
    // useSingularOrPlural(1, 'shuttle defined.', 'shuttles defined.');    // 1 shuttle defined.
    // useSingularOrPlural(2, 'shuttle defined.', 'shuttles defined.');    // 2 shuttles defined.
    public useSingularOrPlural(num: number, singular: string, plural: string): string {
        let text = num.toString() + ' ';
        text += (num === 1) ? singular : plural;

        return text;
    }

    // const queryString = "https://us-central1-shuttlenomix.cloudfunctions.net/smsResponseWebhook?accountNumber=00000-0000-00000&smsType=allAboard&customerName=Michael%20Carr&countryCode=%2B1";
    // const parts = this.parseQueryString(queryString);
    // parts.url = https://us-central1-shuttlenomix.cloudfunctions.net/smsResponseWebhook
    // parts.accountNumber = 00000-0000-00000
    // parts.smsType = allAboard
    // parts.contactName = Michael Carr
    // parts.countryCode = +1
    public parseQueryString(queryString = ''): Record<string, string> {
        if (!queryString) {
            queryString = window.location.search;
        }

        const query = queryString.split('?');
        const parms = query[1].split('&');

        const parts: Record<string, string> = {
            'url': query[0],
        };
        for (let i = 0; i < parms.length; ++i) {
            const p = parms[i].split('=', 2);
            if (p.length === 1) {
                parts[p[0]] = '';
            } else {
                parts[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
            }
        }

        delete parts['url'];
        return parts;
    }

    public shuffle<T>(array: T[]): T[] {
        let randomIndex: number;
        let currentIndex: number = array.length;

        // While there remain elements to shuffle.
        while (currentIndex !== 0) {
            // Pick a remaining element.
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
        }

        return array;
    }

    public getRoleTitle(role: TRole): string {
        let title: string;

        switch (role) {
            case 'accountant':
                title = 'Accountant';
                break;

            case 'driver':
                title = 'Driver';
                break;

            case 'manager':
                title = 'Manager';
                break;

            case 'marketer':
                title = 'Marketer';
                break;

            case 'serviceAdvisor':
                title = 'Service Advisor';
                break;
    
            default:
                title = 'undefined';
                break;
        }
        return title;
    }

    // Usage:
    // try {
    //   do something that might fail
    // } catch (err) {
    //   const errorMessage = this.utilsService.extractError(err);
    //   await this.uxHelperService.showAlert('Error', errorMessage);
    // }
    public extractError(err: unknown, defaultErrorMsg = 'Unknown Error'): string {
        let errorMessage = defaultErrorMsg;

        // err.formattedAddress
        if (typeof err === 'string') {
            errorMessage = err;
        } else if (err instanceof Error) {
            errorMessage = err.message;
        }
        return errorMessage;
    }

    public getColorInfo(idx: number): TDistinctColorInfo {
        const colorInfo: TDistinctColorInfo = Constants.DISTINCT_COLORS[idx];

        // const icon = this.getMarkerIcon(colorInfo.name);
        return colorInfo;
    }

    public findUniqueColor(usedColors: string[]): TDistinctColorInfo {
        const numColors = Constants.DISTINCT_COLORS.length - 1;
        const colorInfo = Constants.DISTINCT_COLORS.find((colorInfo) => !usedColors.includes(colorInfo.name)); 

        // Return found color or default to last color if all are used
        return colorInfo ?? Constants.DISTINCT_COLORS[numColors];
    }
}
